<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <DefectRateReport
          :company="company"
          :part="part"
          :supplier="supplier"
          :dateFrom="dateFrom"
          :dateTo="dateTo"
          :rateListHeader="rateListHeader"
          :rateList="rateList"
          :weekHeader="weekHeader"
          :defectListHeader="defectListHeader"
          :defectList="defectList"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DefectRateReport from '@/components/organisms/report/print/DefectRateReport'

export default {
  name: 'DefectRatePageReport',
  components: { DefectRateReport },
  props: {
    company: {
      type: String,
      required: true,
    },
    part: {
      type: String,
      required: false,
    },
    supplier: {
      type: String,
      required: false,
    },
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    },
    rateListHeader: {
      type: Array,
      required: true,
    },
    rateList: {
      type: Array,
      required: true,
    },
    weekHeader: {
      type: Array,
      required: true,
    },
    defectListHeader: {
      type: Array,
      required: false,
    },
    defectList: {
      type: Array,
      required: false,
    },
  },
}
</script>
